<template>
  <Modal id="CompanyDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('employeeEntryRecord.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
        <DescriptionsItem :label="$t('employeeEntryRecord.field.id_emp_ent_rec')">{{data.idEmpEntRec}}</DescriptionsItem>
        <DescriptionsItem :label="$t('employeeEntryRecord.field.id_emp')">{{data.employeeNameTw}}</DescriptionsItem>
        <DescriptionsItem :label="$t('employeeEntryRecord.field.entry_date')">{{data.entryDate}}</DescriptionsItem>
        <DescriptionsItem :label="$t('employeeEntryRecord.field.term_date')">{{data.termDate}}</DescriptionsItem>
        <DescriptionsItem :label="$t('employeeEntryRecord.field.term_remark')">{{data.termRemark}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "EmployeeEntryRecordDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>